import { trackEvent } from '../../lib/tracking';

const trackIfNecessary = track => {
  if (track) {
    trackEvent(track);
  }
};

export default trackIfNecessary;
